import styled from 'styled-components/macro';
import { TYPOGRAPHY, COLORS } from 'styleguide';

const LastMessageTime = styled.time`
  flex-shrink: 0;
  margin-left: 8px;
  ${TYPOGRAPHY.caption}
  color: ${COLORS.gray60};
`;

export default LastMessageTime;
